// src/pages/Accounting/Reconcile/Summary/summaryMockData.ts

import type { ReconciliationSummaryRow } from "./summaryTypes";

/**
 * One row per reconcilable account, showing its most recent reconciliation.
 * Accounts with null statementEndingDate have never been reconciled and
 * render as "Never" in the UI.
 */
export const mockSummaryRows: ReconciliationSummaryRow[] = [
  {
    accountId: "acct_rbc_chequing",
    accountName: "BrightCare-RBC Chequing",
    accountType: "Bank",
    statementEndingDate: "2026-09-30",
    reconciledOn: "2026-10-01",
    endingBalance: 10214.80,
    currency: "CAD",
  },
  {
    accountId: "acct_rbc_savings",
    accountName: "BrightCare-RBC Savings",
    accountType: "Savings",
    statementEndingDate: "2026-09-30",
    reconciledOn: "2026-10-02",
    endingBalance: 42890.12,
    currency: "CAD",
  },
  {
    accountId: "acct_rbc_visa",
    accountName: "RBC Visa Business",
    accountType: "Credit card",
    statementEndingDate: "2026-09-25",
    reconciledOn: "2026-09-28",
    endingBalance: 1847.33,
    currency: "CAD",
  },
  {
    accountId: "acct_td_usd",
    accountName: "BrightCare-TD USD",
    accountType: "Bank (USD)",
    statementEndingDate: null,
    reconciledOn: null,
    endingBalance: null,
    currency: "USD",
  },
];